import React, { createContext, useContext, useReducer, useEffect } from "react";
import { hotjar } from 'react-hotjar';

import tabsReducer, { initialState } from "./tabsReducer";

export const TabsContext = createContext();

export const TabsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(tabsReducer, initialState);

  const handleTabChange = (_, newValue) => {
    dispatch({
      type: "CHANGE_TAB",
      payload: {
        activeTab: newValue
      },
    });

    hotjar.stateChange(document.URL + '#' + newValue);
  };

  const handleSecondTabChange = (newValue) => {
    dispatch({
      type: "CHANGE_SECOND_TAB",
      payload: {
        secondaryActiveTab: newValue
      },
    });
  };

  return (
    <TabsContext.Provider
      value={{
        handleTabChange,
        activeTab: state.activeTab,
        handleSecondTabChange,
        secondaryActiveTab: state.secondaryActiveTab
      }}
    >
      {children}
    </TabsContext.Provider>
  );
};

const useTabs = (initialize = false) => {
  const context = useContext(TabsContext);

  useEffect(() => {
    if (!initialize) return;

    const tab = window.location.href.split('#');
    if (tab.length === 2) {
      return context.handleTabChange(null, Number(tab[1]));
    }
    context.handleTabChange(null, 1);
  }, []);

  return context;
};

export default useTabs;
